<div class="container_dialog">
    <div class="header_popup">
        <div class="title_popup">
            <img src="../../../../../assets/icones/segments.svg" alt="">
            <span>{{data ? ("segment.update_segment"|translate) :'New Segment'}}</span>
        </div>
        <button class="close_btn" (click)="closed()">
            <img src="assets/icones/close.svg" alt="">
        </button>
    </div>
    <form class="display_form" [formGroup]="form">
        <div class="input_field">
            <label>{{"segment.segment_name"| translate}} <span class="red">*</span></label>
            <input class="input" type="text" formControlName="name"  [placeholder]="'common.name'|translate"  />
            <span class="error_ms" *ngIf="form.get('name')?.touched && form.get('name')?.errors">{{"common.required_field" |translate}}</span>
        </div>
        <div class="input_field">
            <label>{{"common.description"|translate}}</label>
            <input class="input" type="text" formControlName="description" [placeholder]="'common.description'|translate" />
        </div>
        <div class="input_field">
            <label>{{"common.status" | translate}} <span class="red">*</span></label>
            <mat-select disableRipple formControlName="status">
                <mat-option value="draft">{{"common.draft"| translate}}</mat-option>
                <mat-option value="published">{{"segment.segmentsStatus.published"| translate}}</mat-option>
            </mat-select>
        </div>
        <div class="input_field">
            <label>{{"segment.choose_segment_type"| translate}}<span class="red">*</span></label>
            <mat-select [(value)]="selectedSegmentType" formControlName="value_type">
              <mat-option value="single-select">{{"common.single_select"| translate}}</mat-option>
              <mat-option value="multi-select">{{"common.multi_select"| translate}}</mat-option>
              <mat-option value="boolean">{{"segment.yes_no"| translate}}</mat-option>
              <mat-option value="text">{{"inventory.label"| translate}}</mat-option>
            </mat-select>
            <span class="error_ms" *ngIf="form.get('value_type')?.touched && form.get('value_type')?.errors"></span>
          </div>

          <div *ngIf="form.get('value_type')?.value === 'single-select'" class="segment_chip input_field">
              <label>{{"common.single_select"| translate}}</label>
              <mat-chip-list #chipList>
                <mat-chip *ngFor="let chip of chips" (removed)="removeChip(chip)">
                  {{ chip }}
                  <button matChipRemove>
                    <img src="../../../../../assets/icones/delete_red.svg" alt="">
                  </button>
                </mat-chip>
                <input class="input_chip" [placeholder]="'segment.add_option'|translate" [matChipInputFor]="chipList" (matChipInputTokenEnd)="addChip($event)">
              </mat-chip-list>
              <span class="error_ms" *ngIf="form.get('chips')?.hasError('noChips')">
               {{"segment.at_least"|translate}}
              </span>
          </div>

          <div *ngIf="form.get('value_type')?.value === 'multi-select'" class="segment_chip input_field">
              <label>{{"common.multi_select"| translate}}</label>
              <mat-chip-list #multiChipList>
                <mat-chip *ngFor="let chip of multiChips" (removed)="removeMultiChip(chip)">
                  {{ chip }}
                  <button matChipRemove>
                    <img src="../../../../../assets/icones/delete_red.svg" alt="">
                  </button>
                </mat-chip>
                <input class="input_chip" [placeholder]="'segment.add_option'|translate" [matChipInputFor]="multiChipList" (matChipInputTokenEnd)="addMultiChip($event)">
              </mat-chip-list>
              <span class="error_ms" *ngIf="form.get('multiChips')?.hasError('noMultiChips')">
                {{"segment.at_least_one"|translate}}
              </span>
          </div>

          <div *ngIf="form.get('value_type')?.value === 'text'" class="input_field">
              <label>{{"segment.enter_label_value"| translate}}</label>
              <input formControlName="labelValue" class="input">
              <span class="error_ms" *ngIf="form.get('labelValue')?.touched && form.get('labelValue')?.errors">{{"common.required_field" |translate}}</span>
          </div>

    </form>
    <div class="submet_btns">
      <button class="save_btn_pop_up cancel_btn_pop_up" (click)="closed()">
        <span>{{"common.cancel"|translate}}</span>
      </button>
      <button class="save_btn_pop_up blue_btn"  (click)="save()">
        <span>{{data ? ('common.update'| translate) :("common.save" |translate | uppercase)}}</span>
        <img alt="" src="assets/icones/arrow_circle_right.svg">
      </button>
    </div>
</div>
